<script setup lang="ts">
import { ref } from 'vue';
import UserInfoDropdown from './UserInfoDropdown.vue';
import UserAvatar from './UserAvatar.vue';

defineProps<{
	title: string;
	userName: string;
	userEmail?: string;
	logoutLabel?: string;
	imageUrl?: string;
}>();

const isDropdownOpen = ref(false);

const closeDropdown = () => {
	if (isDropdownOpen.value) isDropdownOpen.value = false;
};
</script>

<template>
	<header class="app-header">
		<h2 class="heading">{{ title }}</h2>
		<div class="flex items-center">
			<slot></slot>
			<div class="app-header__user-info" v-click-outside="closeDropdown">
				<button
					class="app-header__user-info__btn"
					type="button"
					tabindex="0"
					aria-label="user info"
					@click="isDropdownOpen = !isDropdownOpen"
				>
					<UserAvatar :user-name="userName" :image-url="imageUrl" class="mr-2" />
					<span class="text-weight-medium">{{ userName }}</span>
				</button>
				<UserInfoDropdown
					v-if="isDropdownOpen"
					:user-name="userName"
					:user-email="userEmail"
					:logout-label="logoutLabel"
					@logout="$emit('logout')"
				/>
			</div>
		</div>
	</header>
</template>

<style lang="scss" scoped>
.app-header {
	height: $height-app-header;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: $spacing-8;
	padding: 0 $spacing-8;
	white-space: nowrap;
	background-color: $color-white;

	&__user-info {
		position: relative;

		&__btn {
			padding: $spacing-2;
			color: $color-neutral-400;
			display: flex;
			align-items: center;
			border-radius: $border-radius-3;
			border: $border-width-2 $border-style transparent;

			&:focus-visible {
				border: $border-width-2 $border-style $color-focus;
			}

			&:focus-within {
				background-color: $color-neutral-100;
			}

			@media (hover: hover) {
				&:hover {
					background-color: $color-neutral-100;
				}
			}
		}
	}
}
</style>
